import React, { useState, useEffect } from 'react';

// Components
import { ResponsiveImage } from '@shopee-user/shared-customization-ui';
import { ResponsiveImageUseCase } from '@shopee-user/business-customization-types';

// Utils
import { config } from '@shopee-user/platform';
import { Locale } from '@shopee-user/global';

// Assets
import logoMdpi from './assets/logo-1x.png';
import logoHdpi from './assets/logo-1.5x.png';
import logoXhdpi from './assets/logo-2x.png';
import logoXxhdpi from './assets/logo-3x.png';
import logoXxxhdpi from './assets/logo-4x.png';

import logoRebrandMdpi from './assets/rebrand/logo-1x.png';
import logoRebrandHdpi from './assets/rebrand/logo-1.5x.png';
import logoRebrandXhdpi from './assets/rebrand/logo-2x.png';
import logoRebrandXxhdpi from './assets/rebrand/logo-3x.png';
import logoRebrandXxxhdpi from './assets/rebrand/logo-4x.png';

import logoOrangeBackgroundMdpi from './assets/orange-background/logo-1x.png';
import logoOrangeBackgroundHdpi from './assets/orange-background/logo-1.5x.png';
import logoOrangeBackgroundXhdpi from './assets/orange-background/logo-2x.png';
import logoOrangeBackgroundXxhdpi from './assets/orange-background/logo-3x.png';
import logoOrangeBackgroundXxxhdpi from './assets/orange-background/logo-4x.png';

import logoOrangeBackgroundBrMdpi from './assets/orange-background/br/logo-1x.png';
import logoOrangeBackgroundBrHdpi from './assets/orange-background/br/logo-1.5x.png';
import logoOrangeBackgroundBrXhdpi from './assets/orange-background/br/logo-2x.png';
import logoOrangeBackgroundBrXxhdpi from './assets/orange-background/br/logo-3x.png';
import logoOrangeBackgroundBrXxxhdpi from './assets/orange-background/br/logo-4x.png';

import { SrcSet } from '@shopee-user/business-customization-types';
import { isBackgroundOrange } from '../../utils/backgroundUtils';

export default function Logo({ className }: { className?: string }) {
  const { LOCALE } = config;
  const [isOrangeBackground, setIsOrangeBackground] = useState(false);

  useEffect(() => {
    // Check background on mount
    setIsOrangeBackground(isBackgroundOrange());
  }, []);

  function getSrcSet(): SrcSet[] {
    switch (LOCALE) {
      case Locale.ID:
        return [
          { src: logoRebrandMdpi, size: '1x' },
          { src: logoRebrandHdpi, size: '1.5x' },
          { src: logoRebrandXhdpi, size: '2x' },
          { src: logoRebrandXxhdpi, size: '3x' },
          { src: logoRebrandXxxhdpi, size: '4x' },
        ];
      case Locale.BR: {
        return [
          { src: logoOrangeBackgroundBrMdpi, size: '1x' },
          { src: logoOrangeBackgroundBrHdpi, size: '1.5x' },
          { src: logoOrangeBackgroundBrXhdpi, size: '2x' },
          { src: logoOrangeBackgroundBrXxhdpi, size: '3x' },
          { src: logoOrangeBackgroundBrXxxhdpi, size: '4x' },
        ];
      }
      case Locale.PH:
      case Locale.TH:
      case Locale.VN:
      case Locale.SG:
      case Locale.MY:
        if (isOrangeBackground) {
          return [
            { src: logoOrangeBackgroundMdpi, size: '1x' },
            { src: logoOrangeBackgroundHdpi, size: '1.5x' },
            { src: logoOrangeBackgroundXhdpi, size: '2x' },
            { src: logoOrangeBackgroundXxhdpi, size: '3x' },
            { src: logoOrangeBackgroundXxxhdpi, size: '4x' },
          ];
        }
        return [
          { src: logoRebrandMdpi, size: '1x' },
          { src: logoRebrandHdpi, size: '1.5x' },
          { src: logoRebrandXhdpi, size: '2x' },
          { src: logoRebrandXxhdpi, size: '3x' },
          { src: logoRebrandXxxhdpi, size: '4x' },
        ];
      default:
        return [
          { src: logoMdpi, size: '1x' },
          { src: logoHdpi, size: '1.5x' },
          { src: logoXhdpi, size: '2x' },
          { src: logoXxhdpi, size: '3x' },
          { src: logoXxxhdpi, size: '4x' },
        ];
    }
  }

  return (
    <ResponsiveImage
      usecase={ResponsiveImageUseCase.AuthLogo}
      className={className}
      defaultSrc={logoXhdpi}
      srcSet={getSrcSet()}
    />
  );
}
